import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,

  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  OutlinedInput,
  Checkbox,
  ListItemText,
  IconButton,
  Typography,
  Autocomplete,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import AlertManagementTable from "./AlertManagementTable";
import PaginationControls from "../../components/Pagination/PaginationControls";
import { addCommaToCurrency } from "../../utils/common/digitCommaSeparation";
import { axiosConfig } from "../../axios/axiosConfig";

// import { addCommaToCurrency } from ".";

const AlertsManagement = () => {
  const [consentChoices, setConsentChoices] = useState([]);
  const [loadingChoices, setLoadingChoices] = useState(false);
  const [symbols, setSymbols] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    symbol_id: "",
    alert_type: "",
    timeframe: "1-d",
    consent_status: [],
    plan_code: [],
  });
  const [consentData, setConsentData] = useState(null);
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [countsArray, setCountsArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subscriptionLoading, setSubcriptionLoading] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [tempValue, setTempValue] = useState([]);

  const offset = 100;
  useEffect(() => {
    fetchUserConsentChoices();
    fetchSymbols();
  }, []);
  useEffect(() => {
    fetchConsentData();
  }, [selectedChoice, page]);
  useEffect(() => {
    fetchSubscriptionPlans();
  }, []);
  const fetchSubscriptionPlans = async () => {
    setSubcriptionLoading(true);
    try {
      const response = await axiosConfig({
        method: "get",
        url: "/subscription/subscription_plan",
      });
      const plansArray =
        response?.data?.response?.plans?.flatMap((p) => p.data || []) || [];
      setSubscriptionPlan(plansArray);
    } catch (error) {
      const errMsg =
        error.response?.data?.response ||
        error.message ||
        "Something went wrong.";
      toast.error(errMsg);
    } finally {
      setSubcriptionLoading(false);
    }
  };

  const fetchConsentData = async () => {
    setLoading(true);
    try {
      let response;

      if (selectedChoice) {
        response = await axiosConfig({
          method: "get",
          url: "/user/consent-all-data",
          params: {
            consent_status: selectedChoice.key,
          },
        });
      } else {
        response = await axiosConfig({
          method: "get",
          url: "/user/consent-all-data",
          params: {
            page: page,
          },
        });
      }

      const data = response?.data?.results || null;

      setConsentData(data?.users || []);
      setTotalCount(data?.counts?.TOTAL || 0);

      if (data?.counts) {
        const arr = Object.entries(data.counts).map(([status, count]) => ({
          status,
          count,
        }));
        setCountsArray(arr);
      }
    } catch (error) {
      const errMsg =
        error.response?.data?.response ||
        error.message ||
        "Something went wrong.";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserConsentChoices = async () => {
    setLoadingChoices(true);
    try {
      const res = await axiosConfig({
        method: "get",
        url: "/user/consent-choices/",
      });

      setConsentChoices(res?.data?.consent_choices || []);
    } catch (error) {
      const errMsg =
        error.response?.data?.response ||
        error.message ||
        "Something went wrong.";
      toast.error(errMsg);
    } finally {
      setLoadingChoices(false);
    }
  };

  const fetchSymbols = async () => {
    try {
      const res = await axiosConfig({
        method: "get",
        url: `/tnibrochart/all-symbol`,
      });
      setSymbols(res?.data?.symbols || []);
    } catch (error) {
      toast.error("Failed to fetch symbols");
    }
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.symbol_id) {
      toast.error("Please select a symbol");
      return;
    }
    if (!formData.alert_type) {
      toast.error("Please select an alert type");
      return;
    }
    if (formData.consent_status.length === 0) {
      toast.error("Please select at least one consent status");
      return;
    }
    if (formData.plan_code.length === 0) {
      toast.error("Please select at least one subscription plan");
      return;
    }

    setSubmitting(true);
    try {
      await axiosConfig({
        method: "post",
        url: "/tnibroadmin/set-user-alert-by-stockyaari/",
        data: formData,
      });

      toast.success("Alert added successfully");
      setFormData({
        symbol_id: "",
        alert_type: "",
        timeframe: "1-d",
        consent_status: [],
        plan_code: [],
      });
      setOpen(false);
    } catch (error) {
      toast.error(error.response?.data?.response || "Failed to add alert");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          px: 3,
          py: 2,
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <NotificationsActiveIcon sx={{ color: "#eef2f7", fontSize: 26 }} />
          <Box>
            <Typography sx={{ color: "#ffffff", fontWeight: 700, fontSize: 18, lineHeight: 1.2 }}>
              Alerts Management
            </Typography>
            <Typography sx={{ color: "#eef2f7", fontSize: 12 }}>
              Manage user alert notifications by consent &amp; plan
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          sx={{
            background: "#016551",
            color: "#fff",
            fontWeight: 600,
            fontSize: 13,
            px: 2.5,
            py: 1,
            borderRadius: "8px",
            textTransform: "none",
            boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
            "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)", boxShadow: "0 6px 16px rgba(1,101,81,0.4)" },
          }}
        >
          + Add Alerts
        </Button>
      </Box>

      {/* Filters Card */}
      <Box
        sx={{
          background: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          p: 2.5,
          mb: 3,
        }}
      >
        {countsArray.length > 0 && (
          <Box display="flex" gap={2} mb={2} flexWrap="wrap">
            {countsArray.map((item, idx) => (
              <Typography key={idx} sx={{ fontSize: 12, fontWeight: 600, color: "#016551", background: "#eef2f7", px: 1.5, py: 0.5, borderRadius: "6px", border: "1px solid #e2e8f0" }}>
                {item.status}: {addCommaToCurrency(item.count)}
              </Typography>
            ))}
          </Box>
        )}
        <Autocomplete
          options={consentChoices}
          getOptionLabel={(option) => option.value}
          loading={loadingChoices}
          onChange={(_, newValue) => setSelectedChoice(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Consent Status"
              variant="outlined"
              size="small"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loadingChoices ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </Box>

      {/* Add Alerts Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden", boxShadow: "0 20px 60px rgba(4,52,58,0.2)" } }}
      >
        <Box sx={{ px: 3, py: 2, background: "#04343a", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>Add Alert</Typography>
          <IconButton onClick={() => setOpen(false)} sx={{ color: "#eef2f7", "&:hover": { color: "#fff" } }} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 1,
            maxHeight: "70vh",
            overflowY: "auto",
            background: "#f8fafc",
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
          }}
        >
          <Autocomplete
            options={symbols}
            getOptionLabel={(option) => option.name || ""}
            value={symbols.find((s) => s.id === formData.symbol_id) || null}
            onChange={(event, newValue) => {
              handleChange("symbol_id", newValue ? newValue.id : "");
            }}
            renderInput={(params) => (
              <TextField {...params} label="Symbol" fullWidth />
            )}
          />

          <Autocomplete
            multiple
            options={[{ plan_code: "__select_all__", name: "Select All" }, ...subscriptionPlan]}
            getOptionLabel={(option) => option?.name || ""}
            loading={subscriptionLoading}
            value={subscriptionPlan.filter((plan) =>
              (formData.plan_code || []).includes(plan.plan_code)
            )}
            onChange={(event, newValue) => {
              if (newValue.some((opt) => opt.plan_code === "__select_all__")) {
                const allSelected = (formData.plan_code || []).length === subscriptionPlan.length;
                handleChange(
                  "plan_code",
                  allSelected ? [] : subscriptionPlan.map((plan) => plan.plan_code)
                );
              } else {
                handleChange(
                  "plan_code",
                  newValue.map((plan) => plan.plan_code)
                );
              }
            }}
            renderOption={(props, option, { selected }) => {
              if (option.plan_code === "__select_all__") {
                const allSelected = (formData.plan_code || []).length === subscriptionPlan.length;
                return (
                  <li {...props} key="__select_all__">
                    <Checkbox checked={allSelected} indeterminate={!allSelected && (formData.plan_code || []).length > 0} />
                    <strong>Select All</strong>
                  </li>
                );
              }
              return (
                <li {...props} key={option.plan_code}>
                  <Checkbox checked={selected} />
                  {option.name}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Plan_Code"
                placeholder="Select Plans"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {subscriptionLoading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />

          <FormControl fullWidth>
            <InputLabel>Alert Type</InputLabel>
            <Select
              value={formData.alert_type}
              onChange={(e) => handleChange("alert_type", e.target.value)}
            >
              <MenuItem value="Buy Alert">Buy Alert</MenuItem>
              <MenuItem value="Sell Alert">Sell Alert</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Timeframe"
            value={formData.timeframe}
            onChange={(e) => handleChange("timeframe", e.target.value)}
            fullWidth
            InputProps={{ readOnly: true }}
          />

          <Autocomplete
            multiple
            options={consentChoices.map((choice) => choice.value)}
            value={formData.consent_status || []}
            onChange={(e, newValue) => {
              if (newValue.includes("NEVERENABLED")) {
                setTempValue(newValue);
                setConfirmOpen(true);
              } else {
                handleChange("consent_status", newValue);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Consent Status" placeholder="Select status" />
            )}
          />
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, background: "#f8fafc" }}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={submitting}
            fullWidth
            sx={{
              background: "#016551",
              color: "#fff",
              fontWeight: 600,
              fontSize: 14,
              py: 1.2,
              borderRadius: "8px",
              textTransform: "none",
              boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
              "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)", boxShadow: "0 6px 16px rgba(1,101,81,0.4)" },
            }}
          >
            {submitting ? <CircularProgress size={22} sx={{ color: "white" }} /> : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <AlertManagementTable loading={loading} consentData={consentData} />
      <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
        <PaginationControls totalCount={totalCount} page={page} setPage={setPage} offset={offset} />
      </Box>

      {/* consent status confirmation */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
      >
        <Box sx={{ px: 3, py: 2, background: "#04343a" }}>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>Confirm Selection</Typography>
        </Box>
        <DialogContent sx={{ mt: 1 }}>
          Are you sure you want to select <strong>NEVERENABLED</strong>?
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            sx={{ color: "#016551", fontWeight: 600, textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => { handleChange("consent_status", tempValue); setConfirmOpen(false); }}
            variant="contained"
            sx={{
              background: "#016551",
              color: "#fff",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
              "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AlertsManagement;
